import React from "react"

import { EditableSearchify, Group, Radio } from "@/components"
import { getMessageFieldName } from "@/pages/campaign-form/components/campaigns/writeALetter/Message.helper"
import { useFormContext } from "react-hook-form"
import {
    ACTIVE_CHILD_CAMPAIGN_TYPE_NAME,
    TARGETED_OFFICIALS_DEFAULT_SELECTION_ERROR,
} from "@/pages/campaign-form/constants"
import type { SafedSearch } from "@/types/djangio"
import { StandardOfficialSelector } from "@/components/StandardOfficialsSelector/StandardOfficialSelector"
import { TargetingRestrictions } from "@/pages/campaign-form/components/sections/message/TargetingRestrictions"
import { isInternational } from "shared/imports/regionConstants"
import { isCustomTargetingEnabled } from "@/pages/campaign-form/helpers"
import { useStyles } from "@/pages/campaign-form/components/sections/message/TargetedOfficialsSelection/TargetedOfficialsSelection.styles"

export interface TargetedOfficialsSelectionProps {
    messageIndex: number
    prefix: string
}
export const TargetedOfficialsSelectionWriteLetter = ({
    messageIndex,
    prefix = null,
}: TargetedOfficialsSelectionProps) => {
    const formContext = useFormContext()
    const { classes } = useStyles()

    const childCampaignType = formContext.getValues(ACTIVE_CHILD_CAMPAIGN_TYPE_NAME)
    const campaignTypeSingleAction = formContext.getValues("campaign_type")
    const childCampaignTypeIsUndefined = childCampaignType === "undefined" || childCampaignType === undefined
    const campaignType = childCampaignTypeIsUndefined ? campaignTypeSingleAction : childCampaignType
    const defaultTargetsSavedSearchName = getMessageFieldName(messageIndex, "standard_options_search", prefix)

    const customOfficialsSearches = formContext.watch(
        getMessageFieldName(messageIndex, "custom_officials_searches", prefix),
    ) as SafedSearch
    if (!customOfficialsSearches) {
        formContext.setValue(getMessageFieldName(messageIndex, "custom_officials_searches", prefix), [])
    }

    return (
        <>
            {Boolean(formContext.watch(getMessageFieldName(messageIndex, "has_custom_email_targets", prefix))) ===
                false && (
                <>
                    {!isInternational && (
                        <Radio.Group
                            name={getMessageFieldName(messageIndex, "uses_default_member_list", prefix)}
                            label="Choose type of officials"
                            transform={{
                                input: (input: boolean) => String(input),
                                output: (output: string) => (output === "true" ? true : false),
                            }}
                        >
                            <Group>
                                <Radio value={"true"} label="Standard" />
                                <Radio
                                    value={"false"}
                                    label={
                                        isCustomTargetingEnabled(formContext)
                                            ? "Group of recipients"
                                            : "Custom officials"
                                    }
                                />
                            </Group>
                        </Radio.Group>
                    )}
                    {formContext.watch(getMessageFieldName(messageIndex, "uses_default_member_list", prefix)) ===
                    true ? (
                        <StandardOfficialSelector label="Choose officials" name={defaultTargetsSavedSearchName} />
                    ) : (
                        <>
                            <div className={isCustomTargetingEnabled(formContext) ? classes.officials_groups : ""}>
                                <EditableSearchify
                                    buttonText="Add officials"
                                    name={getMessageFieldName(messageIndex, "custom_officials_searches", prefix)}
                                    dataType={DjangIO.app.models.QuorumDataType.person}
                                    rules={{
                                        validate: (value) =>
                                            (value && value.length > 0) || TARGETED_OFFICIALS_DEFAULT_SELECTION_ERROR,
                                    }}
                                    defaultFilters={{
                                        for_grassroots: campaignType,
                                        is_custom_targeting_enabled: isCustomTargetingEnabled(formContext),
                                    }}
                                    customEdit={isCustomTargetingEnabled(formContext)}
                                />
                            </div>
                            {isCustomTargetingEnabled(formContext) && (
                                <TargetingRestrictions index={messageIndex} prefix={prefix} />
                            )}
                        </>
                    )}
                </>
            )}
        </>
    )
}
